// @ts-strict-ignore
import styled from 'styled-components';
import { useDispatch, useSelector } from 'src/store/store';
import i18n from 'src/utils/translate';
import { followCommunity } from 'src/modules/community/shared/actions';
import SearchCommunityCard from 'src/modules/search/communities/components/searchCommunityCard';
import CommunityCardLoader from 'src/modules/search/communities/components/communityCardLoader';
import FollowSuccessMessage from 'src/modules/community/shared/components/alert/followSuccessMessage';
import Pagination from 'src/components/pagination/pagination';
import paginationResultsPerPage from 'src/constants/paginationResultsPerPage';
import { EmptyStateCount, QueryText } from 'src/modules/tag/sharedStyles';
export default function TagCommunitiesList(): JSX.Element {
  const dispatch = useDispatch();
  const {
    isLoading,
    results,
    tagName,
    totalResults
  } = useSelector(state => state.pages.tag.communities);
  const count = Number(totalResults).toLocaleString();
  const text = totalResults === 1 ? i18n.t('public community') : i18n.t('public communities');
  const onFollowCommunity = async community => {
    await dispatch(followCommunity({
      communitySlug: community.slug,
      successMessage: <FollowSuccessMessage communityName={community.name} />
    }));
  };
  return <CommunitiesContainer data-sentry-element="CommunitiesContainer" data-sentry-component="TagCommunitiesList" data-sentry-source-file="tagCommunitiesList.tsx">
      {isLoading && <CommunityCardLoader />}
      {!isLoading && totalResults === 0 && <>
          <EmptyStateCount>0 {i18n.t('public')} {i18n.t('communities')}</EmptyStateCount>
          <div>
            {i18n.t(`Sorry, we don't have any public `)} {i18n.t('communities')} {i18n.t(' matching ')}
            <QueryText>{tagName}</QueryText>
          </div>
        </>}
      {!isLoading && totalResults > 0 && <>
          <ResultsCount>
            {`${count} ${text}`}
          </ResultsCount>

          <ListContainer>
            {results.map(community => <SearchCommunityCard community={community} key={community.communityId} onFollowCommunity={onFollowCommunity} />)}
          </ListContainer>
          <Pagination isShowBotLinks={true} lastPageOverride={100} pageSize={paginationResultsPerPage.searchCommunities} total={totalResults} />
        </>}
    </CommunitiesContainer>;
}
const CommunitiesContainer = styled.div`
  min-height: 300px;
  max-width: 1200px;
  margin: 0 auto 60px;
  padding: 15px;

  @media (${({
  theme
}) => theme.underScreenXlarge}) and (${({
  theme
}) => theme.overScreenSmall}) {
    margin: 0 20px;
  }
  @media (${({
  theme
}) => theme.underScreenSmall}) {
    padding: 0 15px;
  }
`;
const ResultsCount = styled.div`
  height: 30px;
  margin-bottom: 5px;
`;
const ListContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;